import { ZohoRelatedMeter } from "../../services/zoho.service";

export type MeterFuelType = "electricity" | "gas";

export const getMeterFuelType = (meter: ZohoRelatedMeter): MeterFuelType | null => {
  if (meter.mprn) return "gas";
  if (meter.mpan) return "electricity";
  return null;
};

export const getMeterNumber = (meter: ZohoRelatedMeter, fuel: MeterFuelType): string | null =>
  fuel === "gas" ? meter.mprn : meter.mpan;

export const formatMeterName = (name: string | null): string => {
  if (!name) return "Unnamed meter";
  return name
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
